export class SQSRecordToPatientEventNotificationConverter {
    toModel = (source) => {
        return JSON.parse(source.body);
    };
    static create = () => {
        return new SQSRecordToPatientEventNotificationConverter();
    };
}
